module.exports = __webpack_public_path__ + "img/login-img-4.7d0e4bab.svg";